import { AppTextFieldProps } from './AppTextField.types'
import style from './AppTextField.module.scss'
import { ChangeEvent, InvalidEvent, useEffect, useRef, useState } from 'react'

export default function AppTextField({
  name,
  value,
  label,
  type,
  required,
  pattern,
  error,
  onFieldChange,
}: AppTextFieldProps) {
  const [hasError, setHasError] = useState(false)
  const [isLabelLazy, setIsLabelLazy] = useState(true)
  const initialRender = useRef(false)

  function validateField() {
    setHasError(false)
    if (required) {
      if (!value) setHasError(true)
      if (!pattern) return
      const _p = new RegExp(pattern, 'g')
      setHasError(!_p.test(value))
    }
  }

  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    if (!onFieldChange) return
    initialRender.current = true
    onFieldChange({
      field: name,
      value: e.target.value,
    })
  }

  function handleInvalid(e: InvalidEvent<HTMLInputElement>) {
    e.preventDefault()
    validateField()
  }

  function handleFocus() {
    setIsLabelLazy(false)
  }

  function handleBlur() {
    if (!value) setIsLabelLazy(true)
  }

  useEffect(() => {
    setIsLabelLazy(!value)
    if (initialRender.current) {
      validateField()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, pattern])

  return (
    <div className={style.container}>
      {label && (
        <label
          htmlFor={name}
          className={`
            ${style.label} 
            ${(!isLabelLazy && style.active) || ''}
          `}
        >
          {label}
        </label>
      )}

      <input
        id={name}
        className={`${style.field} ${(hasError && style['has-error']) || ''}`}
        type={type || 'text'}
        name={name}
        required={required}
        value={value}
        pattern={pattern}
        onChange={handleChange}
        onInvalid={handleInvalid}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />

      {hasError && <span className={style.error}>{error}</span>}
    </div>
  )
}
